import { FC } from 'react'
import { InputContainerButton } from './common'

interface Props {
  onClick: () => void
  disabled?: boolean
}

const MatchBPMButton: FC<Props> = ({ onClick, disabled }) => {
  return (
    <InputContainerButton
      onClick={() => onClick()}
      tooltipText="Match Song Tempo"
      disabled={disabled}
    >
      Match
    </InputContainerButton>
  )
}

export default MatchBPMButton
